import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationsApi } from './api';

const KEYS = {
    notifications: ['notifications'] as const,
    unreadCount: ['notifications', 'unread-count'] as const,
};

export function useNotifications(page = 1) {
    return useQuery({
        queryKey: [...KEYS.notifications, page],
        queryFn: () => notificationsApi.list(page).then((r) => r.data),
    });
}

export function useUnreadCount() {
    return useQuery({
        queryKey: KEYS.unreadCount,
        queryFn: () => notificationsApi.unreadCount().then((r) => r.data.count),
        refetchInterval: 30_000, // poll every 30 seconds
    });
}

export function useMarkRead() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id: string) => notificationsApi.markRead(id),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: KEYS.notifications });
            qc.invalidateQueries({ queryKey: KEYS.unreadCount });
        },
    });
}

export function useMarkAllRead() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: () => notificationsApi.markAllRead(),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: KEYS.notifications });
            qc.invalidateQueries({ queryKey: KEYS.unreadCount });
        },
    });
}
